import { createContext } from "react";
import { Customer } from "../../types";

/* Context to store customer details */
export const CustomerContext = createContext<Customer | undefined | null>(null);
